import { createFileRoute, redirect } from '@tanstack/react-router'

/** /commissions: the runs are commission's home. */
export const Route = createFileRoute('/_app/commissions/')({
  beforeLoad: () => {
    throw redirect({ to: '/commissions/runs', replace: true })
  },
})
